import competencyServices from 'admin/services/competencies'
import { actions } from 'react-redux-form'

export const setDefaultCompetencies = (positionId, context) => dispatch => competencyServices.setDefaultCompetencies(positionId, context)
  .then((competencyNames) => {
    dispatch(actions.change(`${context}.competencyNames`, competencyNames))
  })
